<template>
  <div class="loginContainer">
    <div class="content">
      <div class="left"></div>
      <div class="login">
        <div class="title">久智建管</div>
        <div class="form-wrap">
          <div class="login-form" key="login" v-if="!isRegister">
            <div class="tab">
              <div class="item" v-for="(item, index) in tabs" :class="{ active: currentTab === index.toString() }"
                @click="tabChange(index)" :key="index">{{ item }}</div>
            </div>
            <template v-if="currentTab === '0'">
              <el-form ref="form" key="login-form" :model="loginForm" :rules="loginRules" :hide-required-asterisk="true">
                <el-form-item prop="loginId">
                  <el-input v-model="loginForm.loginId" placeholder="请输入登录账号" autocomplete="off"
                    @blur="getLoginCode(false)">
                    <template slot="append">
                      <i v-if="loginForm.loginId" @click='loginForm.loginId = ""' class="el-icon-close"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="customCodeList && customCodeList.length > 1">
                  <el-select class="customer" v-model="customerCode" clearable>
                    <el-option v-for="(item, index) of customCodeList" :key="index" :label="item.customerName"
                      :value="item.customerCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="loginForm.password" placeholder="请输入登录密码" type="password" autocomplete="off"
                    @keyup.enter.native='submit'>
                    <template slot="append">
                      <i v-if="loginForm.password" @click='loginForm.password = ""' class="el-icon-close"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-checkbox v-model="isRememberPsd">记住密码</el-checkbox>
              </el-form>
              <el-button class="submit" type="primary" @click="submit()" :loading="loading">登 录</el-button>
            </template>
            <template v-else>
              <el-form ref="smsForm" key="sms-form" :model="smsForm" :rules="smsRules" :hide-required-asterisk="true">
                <el-form-item prop="mobile">
                  <el-input v-model="smsForm.mobile" placeholder="请输入手机号" autocomplete="off"
                    @blur="getLoginCode(false)">
                    <template slot="append">
                      <i v-if="smsForm.mobile" @click='smsForm.mobile = ""' class="el-icon-close"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="customCodeList && customCodeList.length > 1">
                  <el-select class="customer" v-model="customerCode" clearable>
                    <el-option v-for="(item, index) of customCodeList" :key="index" :label="item.customerName"
                      :value="item.customerCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="imgVerifyCode">
                  <div class="verifyCode">
                    <el-input v-model="smsForm.imgVerifyCode" placeholder="请输入图形验证码" autocomplete="off"
                      @keyup.enter.native='smsSubmit'>
                      <template slot="append">
                        <i v-if="smsForm.imgVerifyCode" @click='smsForm.imgVerifyCode = ""' class="el-icon-close"></i>
                      </template>
                    </el-input>
                    <img :src="verifyCodeImg" @click="verifyCodeUpdate" onerror="this.src = '';this.onerror=null">
                  </div>
                </el-form-item>
                <el-form-item prop="verifyCode">
                  <div class="verifyCode sms">
                    <el-input v-model="smsForm.verifyCode" placeholder="请输入短信验证码" autocomplete="off"
                      @keyup.enter.native='smsSubmit'>
                      <template slot="append">
                        <i v-if="smsForm.verifyCode" @click='smsForm.verifyCode = ""' class="el-icon-close"></i>
                      </template>
                    </el-input>
                    <p v-if="leftSeconds" class="c-gray">{{ leftSeconds }}秒</p>
                    <p v-else @click="sendSms">获取短信验证码</p>
                  </div>
                </el-form-item>
              </el-form>
              <el-button class="submit" type="primary" @click="smsSubmit()" :loading="loading">登 录</el-button>
            </template>
          </div>
          <div class="register-form" key="register" v-else>
            <div class="register-tip">
              <span>现在注册即可免费体验</span>
            </div>
            <el-form ref="registerForm" :model="registerForm" :rules="registerRules" :hide-required-asterisk="true">
              <el-form-item prop="customerName">
                <el-input v-model="registerForm.customerName" placeholder="企业名称" autocomplete="off">
                  <template slot="append">
                    <i v-if="registerForm.customerName" @click='registerForm.customerName = ""'
                      class="el-icon-close"></i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="registerPhone">
                <el-input v-model="registerForm.registerPhone" placeholder="手机号" autocomplete="off">
                  <template slot="append">
                    <i v-if="registerForm.registerPhone" @click='registerForm.registerPhone = ""'
                      class="el-icon-close"></i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="imgVerifyCode">
                <div class="verifyCode">
                  <el-input v-model="registerForm.imgVerifyCode" placeholder="图形验证码" autocomplete="off">
                    <template slot="append">
                      <i v-if="registerForm.imgVerifyCode" @click='registerForm.imgVerifyCode = ""'
                        class="el-icon-close"></i>
                    </template>
                  </el-input>
                  <img :src="verifyCodeImg" @click="verifyCodeUpdate" onerror="this.src = '';this.onerror=null">
                </div>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <div class="verifyCode sms">
                  <el-input v-model="registerForm.verifyCode" placeholder="短信验证码" autocomplete="off">
                    <template slot="append">
                      <i v-if="registerForm.verifyCode" @click='registerForm.verifyCode = ""' class="el-icon-close"></i>
                    </template>
                  </el-input>
                  <p v-if="leftSeconds" class="c-gray">{{ leftSeconds }}秒</p>
                  <p v-else @click="registerSendSms">获取短信验证码</p>
                </div>
              </el-form-item>
              <el-form-item prop="adminPassword">
                <el-input v-model="registerForm.adminPassword" placeholder="初始密码（非必填，默认为手机号后6位）" autocomplete="off">
                  <template slot="append">
                    <i v-if="registerForm.adminPassword" @click='adminPassword.adminPassword = ""'
                      class="el-icon-close"></i>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button class="submit" type="primary" @click="registerSubmit" :loading="loading">注 册</el-button>
          </div>
        </div>

        <div class="register" v-if="!isRegister">
          <span>没有账号？</span>
          <span @click="isRegister = true">立即注册</span>
        </div>
        <div v-else class="return-login" @click="isRegister = false">
          <img src="@/assets/img/layout/return-login.png" />
          <span>返回登录</span>
        </div>
      </div>
    </div>
    <div class="support">江苏久智环境科技服务有限公司提供技术支持</div>
  </div>
</template>

<script>
import { deepClone } from '@/utils/util'

export default {
  name: 'Login',
  data() {
    return {
      isRegister: false,
      customCodeList: [],
      customerCode: '',
      tabs: ['账号登录', '手机号登录'],
      currentTab: '0',
      isRememberPsd: false,
      loading: false,
      loginForm: {
        loginId: '',
        password: ''
      },
      loginRules: {
        loginId: [
          { required: true, message: '请输入登录账号' }
        ],
        password: [
          { required: true, message: '请输入登录密码' }
        ]
      },
      verifyCodeImg: '',
      sendDisabled: false,
      leftSeconds: '',
      smsForm: {
        mobile: '',
        imgVerifyCode: '',
        verifyCode: ''
      },
      smsRules: {
        mobile: [
          { required: true, message: '请输入手机号' }
        ],
        imgVerifyCode: [{ required: true, message: '请输入图形验证码' }],
        verifyCode: [
          { required: true, message: '请输入短信验证码' }
        ]
      },
      registerForm: {
        imgVerifyCode: '',
        customerName: '', // 企业名称
        adminPassword: '', // 初始密码
        registerPhone: '', // 手机号
        verifyCode: '' // 验证码
      },
      registerRules: {
        customerName: [
          { required: true, message: '请输入企业名称' }
        ],
        registerPhone: [
          { required: true, message: '请输入手机号' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }
        ],
        verifyCode: [
          { required: true, message: '请输入短信验证码' }
        ]
      }
    }
  },
  computed: {
    mainMenuIndex() {
      return parseInt(this.$store.state.mainMenuIndex)
    },
    topMenuList() {
      return this.$store.getters.topMenuList
    },
    leftMenuList() {
      return this.topMenuList[this.mainMenuIndex].childNode || []
    }
  },
  watch: {
    customerCode(code) {
      this.$store.commit('setCustomer', code)
    }
  },
  created() {
    this.getRememberInfo()
    this.verifyCodeUpdate()
  },
  mounted() {
    this.$nextTick(() => {
      this.getLoginCode(true)
    })
  },
  methods: {
    tabChange(index) {
      this.currentTab = index.toString()
    },
    getLoginCode(state) {
      let loginId = ''
      if (this.currentTab === '0') {
        loginId = this.loginForm.loginId
      } else {
        loginId = this.smsForm.mobile
      }
      if (loginId) {
        this.$axios.get(this.$apis.common.getLoginCode, {
          loginId: loginId
        }).then(res => {
          this.customCodeList = res || []
          if (this.customCodeList && this.customCodeList.length) {
            if (state) {
              const customerCode = this.$store.state.customerCode
              if (customerCode && this.customCodeList.some(item => item.customerCode === customerCode)) {
                this.customerCode = customerCode
              } else {
                this.customerCode = this.customCodeList[0].customerCode
              }
            } else {
              this.customerCode = this.customCodeList[0].customerCode
            }
          }
        })
      } else {
        this.customerCode = ''
        this.customCodeList = []
      }
    },
    getRememberInfo() {
      const info = JSON.parse(localStorage.getItem('loginInfo'))
      if (info && info.loginId) {
        this.isRememberPsd = true
        this.loginForm = {
          loginId: info.loginId,
          password: info.password
        }
      }
    },
    verifyCodeUpdate() {
      this.verifyCodeImg = this.$apis.common.getAdVerifyCode + '?d=' + Number(new Date())
    },
    sendSms() {
      if (this.smsForm.mobile && this.smsForm.imgVerifyCode) {
        this.$axios.post(this.$apis.common.sendAdSms, {
          mobile: this.smsForm.mobile,
          verifyCode: this.smsForm.imgVerifyCode
        }).then(() => {
          this.sendLimit()
        }).catch((err) => {
          this.verifyCodeUpdate()
        })
      } else {
        this.$message.warning('请输入手机号及图形验证码')
      }
    },
    sendLimit() {
      this.sendDisabled = true
      this.leftSeconds = 60
      const interval = setInterval(() => {
        this.leftSeconds--
        if (this.leftSeconds === 0) {
          clearInterval(interval)
        }
      }, 1000)
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$axios.post(this.$apis.common.login, this.loginForm).then(res => {
            this.onSuccess(res)
          }).catch((err) => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    smsSubmit() {
      this.$refs.smsForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$axios.post(this.$apis.common.smsLogin, {
            mobile: this.smsForm.mobile,
            verifyCode: this.smsForm.verifyCode
          }).then(res => {
            this.onSuccess(res)
          }).catch((err) => {
            console.log(err)
            this.verifyCodeUpdate()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    registerSendSms() {
      if (this.registerForm.registerPhone && this.registerForm.imgVerifyCode) {
        this.$axios.post(this.$apis.common.registerSendSms, {
          mobile: this.registerForm.registerPhone,
          verifyCode: this.registerForm.imgVerifyCode
        }).then(() => {
          this.sendLimit()
        }).catch((err) => {
          this.verifyCodeUpdate()
          this.registerForm.imgVerifyCode = ''
        })
      } else {
        this.$message.warning('请输入手机号及图形验证码')
      }
    },
    registerSubmit() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const formData = deepClone(this.registerForm)
          delete formData.imgVerifyCode
          this.$axios.post(this.$apis.common.registerCustomer, formData).then(res => {
            this.$message.success('注册已提交，请等待审核，审核通过后将通过短信告知，在进行登录操作')
            this.$refs.registerForm.resetFields()
            this.isRegister = false
          }).catch((err) => {
            console.log(err)
            this.verifyCodeUpdate()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    onSuccess(res) {
      this.$store.commit('setToken', res.token)
      this.$store.commit('setUserInfo', res.user)
      if (this.isRememberPsd) {
        localStorage.setItem('loginInfo', JSON.stringify(this.loginForm))
      }
      this.$store.dispatch('getProjectList')
      this.$store.dispatch('getMenu').then(res => {
        if (res && res.length) {
          const url = this.findFirstLeafUrl(this.leftMenuList)
          this.$router.replace(url)
        } else {
          this.$message.warning('暂无权限')
        }
      })
    },
    findFirstLeafUrl(menuList) {
      // 处理空数组或无效输入
      if (!Array.isArray(menuList) || menuList.length === 0) {
        return null; // 或根据需求返回 undefined/空字符串
      }

      // 定义递归函数：深度优先搜索第一个叶子节点
      const getFirstLeaf = (node) => {
        // 检查是否有子节点且子节点数组非空
        if (node.childNode && node.childNode.length > 0) {
          // 递归处理第一个子节点
          return getFirstLeaf(node.childNode[0]);
        } else {
          // 当前节点是叶子节点，返回 url
          return node.url || null; // 处理无 url 的情况
        }
      }
      // 从第一个菜单项开始查找
      return getFirstLeaf(menuList[0])
    }
  }
}
</script>

<style scoped lang="scss">
.loginContainer {
  position: relative;
  background: url(~@/assets/img/login/bg.png) no-repeat center center /cover;
  background-size: cover;
  overflow: hidden;
  height: 100vh;

  .content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .left {
      width: 650px;
      height: 476px;
      background: url(~@/assets/img/login/img.png) no-repeat center center /cover;
      background-size: 100%;
    }

    .login {
      position: relative;
      width: 516px;
      min-height: 518px;
      backdrop-filter: blur(0px);
      border-radius: 40px;
      padding: 60px 54px 63px;
      margin: 0 50px;

      .title {
        width: 100%;
        height: 50px;
        font-family: '35--Regular';
        font-weight: 400;
        font-size: 50px;
        color: #09141D;
        text-align: center;
        margin-bottom: 80px;
      }

      .tab {
        display: flex;
        align-items: center;

        .item {
          width: auto;
          height: 38px;
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #09141D;
          line-height: 34px;
          margin-right: 40px;
          cursor: pointer;

          &.active {
            position: relative;
            color: #0084FF;

            &:before {
              content: '';
              position: absolute;
              bottom: 0;
              left: calc(50% - 25px);
              width: 50px;
              height: 4px;
              background: #0084FF;
              border-radius: 2px;
            }
          }
        }
      }
    }

    ::v-deep {
      .el-form {
        margin: 24px 0 36px;

        .el-form-item {
          position: relative;
          margin-bottom: 24px;

          .el-input {
            width: 430px;
            height: 50px;

            input {
              background: #FFFFFF;
              border-radius: 10px;
              border: 1px solid #C9C9C9;
              height: 100%;
              padding: 10px 20px;
              color: #333333;
            }
          }

          .el-input-group--append {
            input {
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              border-right: 0;
              height: 50px;
            }

            input:-webkit-autofill,
            input:-webkit-autofill:hover,
            input:-webkit-autofill:focus {
              -webkit-box-shadow: none !important;
            }
          }

          .el-input-group__append,
          .el-input-group__prepend {
            background: transparent;
            border: 1px solid #C9C9C9;
            border-left-width: 0;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
          }

          .el-form-item__content {
            margin-left: 0px !important;
          }

          /*.el-form-item__label{*/
          /*  position: absolute;*/
          /*  z-index: 999;*/
          /*  left: 20px;*/
          /*  font-size: 16px;*/
          /*  font-family: PingFangSC-Regular, PingFang SC;*/
          /*  font-weight: 400;*/
          /*  color: #CCCCCC;*/
          /*  line-height: 56px;*/
          /*}*/
          .el-input__inner {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 28px;
          }

          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus {
            color: #ffffff;
            -webkit-box-shadow: 0 0 0 1px rgba(72, 71, 79, 0.5) inset !important;
            /* -webkit-text-fill-color: #fff; */
            -webkit-transition-delay: 99999s;
            -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
          }
        }
      }

      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 18px;
            height: 18px;
            border-radius: 6px;
            border: 1px solid #AFAFAF;
          }

          &.is-checked .el-checkbox__inner {
            background: #0084FF;

            &::after {
              top: 3px;
              left: 6px;
            }
          }
        }

        .el-checkbox__label {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #323A40;
          line-height: 18px;
        }
      }
    }

    .el-button {
      width: 430px;
      height: 60px;
      background: linear-gradient(-90deg, #09BBFE, #5A42EC);
      box-shadow: 0px 10px 16px 0px #8AACDF;
      border-radius: 10px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
      text-shadow: 0px 2px 5px #1A1A1A;
    }
  }

  .verifyCode {
    width: 430px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .el-input {
      width: 65% !important;
    }

    p,
    img {
      width: 30%;
      height: 50px;
      color: var(--color-primary);
      line-height: 48px;
      text-align: center;
      border-radius: 10px;
      cursor: pointer;
    }

    &.sms {
      border: 1px solid #C9C9C9;
      border-radius: 10px;

      ::v-deep .el-input {
        box-shadow: none !important;

        .el-input-group__append,
        .el-input-group__prepend,
        input {
          border-width: 0px !important;
        }
      }
    }
  }

  .support {
    position: absolute;
    left: calc(50% - 167px);
    bottom: 154px;
    width: 334px;
    height: 15px;
    font-family: "35--Regular";
    font-weight: 400;
    font-size: 14px;
    color: #3C6180;
  }
}

.register-tip {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
}

.return-login {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;

  img {
    width: 26px;
    height: 26px;
    margin-right: 10px;
  }

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  background: #F4F9FB;
  border: 2px dashed #809FB8;
  width: 200px;
  margin: 20px auto;
  border-radius: 12px;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    &:nth-child(1) {
      color: #000000;
    }

    &:nth-child(2) {
      color: #217EFD;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
